var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.activateSpinner
        ? _c("spinner")
        : _c("div", [
            _vm.formType !== "edit"
              ? _c(
                  "div",
                  [
                    _c(
                      "div",
                      [
                        _c(
                          "form-accordion",
                          {
                            attrs: {
                              title: _vm.$t("common.security.ssh"),
                              isTitleUpperCase: false,
                            },
                          },
                          [
                            _c(
                              "b-row",
                              {
                                staticClass:
                                  "d-flex justify-content-center align-items-center",
                              },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        "input-value": _vm.currentSSH.pod,
                                        isMandatory: "",
                                        inputLabel: _vm.$t(
                                          "common.security.pod_select"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.pod_select"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "form-group",
                                    attrs: { sm: "6" },
                                  },
                                  [
                                    _c("form-read-group-label-input", {
                                      attrs: {
                                        "input-value": _vm.currentSSH.name,
                                        isMandatory: "",
                                        inputLabel: _vm.$t(
                                          "common.security.name"
                                        ),
                                        placeholderValue: _vm.$t(
                                          "common.security.name"
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-end" },
                      [
                        _vm.isEditable && _vm.formType !== "add"
                          ? _c(
                              "b-col",
                              { attrs: { cols: "4", lg: "2", xl: "1" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.switchMode("view")
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("common.cncl"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isEditable && _vm.formType !== "add"
                          ? _c(
                              "b-col",
                              { attrs: { cols: "4", lg: "2", xl: "1" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.switchMode("edit")
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-pencil",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(_vm.$t("administration.edit"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isEditable && _vm.formType !== "add"
                          ? _c(
                              "b-col",
                              { attrs: { cols: "4", lg: "2", xl: "1" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "primary" },
                                    on: { click: _vm.deleteSSH },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa-light fa-trash",
                                    }),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("rights.delete"))),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c("ssh-form-edit", {
                      attrs: {
                        pod: _vm.currentSSH.pod,
                        password: _vm.currentSSH.privateKeyPassword,
                        id: _vm.currentSSH.id,
                        name: _vm.currentSSH.name,
                      },
                    }),
                  ],
                  1
                ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }